module.exports = __webpack_public_path__ + "img/spices-and-pastes.73d0dd72.png";